import React, { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { user, login, loading } = useAuth();
  const [email, setEmail] = useState("a.tozzi@tozzieassociati.it");
  const [password, setPassword] = useState("Tozzi2026!");
  const [busy, setBusy] = useState(false);

  if (loading) return <div className="min-h-screen flex items-center justify-center text-navy-800"><Loader2 className="animate-spin" /></div>;
  if (user) return <Navigate to="/dashboard" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (!res.ok) toast.error(res.error || "Credenziali non valide");
    else toast.success("Accesso riuscito");
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="flex items-center justify-center p-8 bg-white">
        <div className="w-full max-w-md space-y-8 animate-fade-in">
          <div className="flex items-center gap-3">
            <img src="https://tozzieassociati.it/wp-content/uploads/2021/10/Tozzi-e-Associati-logo.png" alt="Tozzi e Associati" className="h-12 w-auto" />
            <div className="border-l border-slate-200 pl-3">
              <div className="font-heading font-bold text-sm text-navy-900">Studio Manager</div>
              <div className="text-[10px] text-slate-500 uppercase tracking-wider">Piattaforma riservata</div>
            </div>
          </div>

          <div>
            <h1 className="text-3xl font-heading font-bold text-navy-900 tracking-tight">Bentornato</h1>
            <p className="text-sm text-slate-500 mt-2">Accedi alla piattaforma di gestione dello studio</p>
          </div>

          <form onSubmit={onSubmit} className="space-y-4" data-testid="login-form">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email-input" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Password</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password-input" />
            </div>
            <Button type="submit" disabled={busy} className="w-full bg-navy-800 hover:bg-navy-900 text-white" data-testid="login-submit-button">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Accedi"}
            </Button>
          </form>

          <div className="relative">
            <div className="absolute inset-0 flex items-center"><span className="w-full border-t border-slate-200" /></div>
            <div className="relative flex justify-center text-xs uppercase tracking-wider"><span className="bg-white px-2 text-slate-400">oppure</span></div>
          </div>

          <Button type="button" variant="outline" disabled className="w-full" data-testid="ms-login-button">
            <svg className="w-4 h-4 mr-2" viewBox="0 0 23 23"><path fill="#f25022" d="M1 1h10v10H1z"/><path fill="#00a4ef" d="M1 12h10v10H1z"/><path fill="#7fba00" d="M12 1h10v10H12z"/><path fill="#ffb900" d="M12 12h10v10H12z"/></svg>
            Accedi con Microsoft (richiede configurazione)
          </Button>

          <div className="text-xs text-slate-400 text-center pt-4">
            Demo: a.tozzi@tozzieassociati.it · Tozzi2026!
          </div>
        </div>
      </div>
      <div className="hidden lg:block relative overflow-hidden bg-navy-900">
        <img src="https://images.pexels.com/photos/35735960/pexels-photo-35735960.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=940" alt="Studio" className="absolute inset-0 w-full h-full object-cover opacity-90" />
        <div className="absolute inset-0 bg-gradient-to-tr from-navy-900/80 via-navy-800/40 to-transparent" />
        <div className="relative h-full flex flex-col justify-end p-12 text-white">
          <div className="text-3xl font-heading font-bold leading-tight">Una sola piattaforma.<br/>Per tutto il tuo studio.</div>
          <p className="text-sm text-navy-100 mt-3 max-w-md">Pratiche, documenti, contatti, email e AI assistant. Riservato a professionisti.</p>
        </div>
      </div>
    </div>
  );
}
